import url from 'url'

// Params ( page, '25' )
// Result => `page=25`
export const stringQuery = (key: string, value: string): string => {
  if (!key || !value) {
    return ''
  }

  return `${key}=${value}`
}
// Params ( styles, ['Fine Art', 'Figurative', 'Modern' ])
// Result => `styles[]=fine-art&styles[]=figurative&styles[]=modern`
export const arrayQuery = (key: string, values: Array<any>): string => {
  if (!values.length) {
    return ''
  }

  // If only 1 item NO BRACKETS => `styles=fine-art`
  return values.map((value) => `${key}${values.length > 1 ? '[]' : ''}=${slugify(value)}`).join('&')
}
// We need a way to pull SPECIAL Query Params for ALGOLIA
// Ex: hitsPerPage, page, sort
export const getAlgoliaQueryParams = (href: string = ''): Record<string, any> => {
  const { pathname, query } = url.parse(href, true)
  const { hitsPerPage, page, sort, width, height } = query || {}
  return {
    printsPath: (pathname || '').search(/\/prints/g) > -1,
    // Check if 'PRINTS' path for different indice
    hitsPerPage: hitsPerPage || 100,
    page,
    sort,
    width,
    height,
    href,
  }
}

export const urlQuery = (obj: Record<string, any>) => {
  const query = Object.entries(obj)
    .filter(([key, value]) => {
      // Remove EMPTY and FALSE values => '', false, 0
      if (!value) {
        return false
      }

      return true
    })
    .map(([key, value]) =>
      Array.isArray(value)
        ? arrayQuery(key, value.filter(Boolean))
        : stringQuery(String(key), String(value))
    )
    .filter(Boolean)
    .join('&')
  return query.length ? `?${query}` : ``
}
